// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const sessionSections: PaneSection[] = [
  {
    section: 'security',
    title: 'Security recommendations',
    body: 'A quick health check for your account. Follow the tips here to keep your sign-ins safe.',
  },
  {
    section: 'where',
    title: "Where you're logged in",
    body: 'See every device that is currently signed in to your account. Review this list if anything looks unfamiliar.',
  },
  {
    section: 'current',
    title: 'This device',
    body: 'The device you are using right now. Use its menu to sign out or erase this device if you are on a shared computer.',
  },
  {
    section: 'other',
    title: 'Other sessions',
    body: 'All your other signed-in devices. Sign out of any you no longer use or do not recognise, one at a time or in bulk.',
  },
];
